/* eslint-disable @typescript-eslint/no-unused-vars */
import { Injectable } from '@angular/core';
import { QuickRepliesElementsConfiguration } from '../models';

@Injectable({
  providedIn: 'root',
})
export abstract class StrategyAbstractService {
  constructor() {}

  getTaskTypesGroups() {
    return [
      {
        translateKey: this.getTypeString(),
        taskTypes: this.getAllTasksTypes(),
      },
    ];
  }

  getTypeString(): string {
    return null;
  }

  getAllTasksTypes(): number[] {
    return [];
  }

  getType(): number {
    return null;
  }

  getTaskTypeQueueId(taskType: number): string {
    return null;
  }

  taskTypeCanHaveMentionBtn(taskType: number): boolean {
    return false;
  }

  canHaveSurveys(): boolean {
    return false;
  }

  getPublicTaskTypes(): number[] {
    return [];
  }

  getQuickRepliesElementsConfig(): QuickRepliesElementsConfiguration {
    return null;
  }

  /*
   * For facebook, we removed event comments from the inbox list as the API doesn't allow us to retreive them anymore,
   * but the history must remain acccessible in the search and metric pages
   */
  getAllTasksTypesForSearchAndMetrics(): number[] {
    return this.getAllTasksTypes();
  }

  getAllTasksTypesForInbox(): number[] {
    return this.getAllTasksTypes();
  }

  taskTypeHasPublicationFilter(taskType: number): boolean {
    return false;
  }

  taskTypeHasMentionFilter(taskType) {
    return false;
  }

  taskTypeHasPublicRepliesFilter(taskType) {
    return false;
  }

  externalInboxURL(site): string {
    return null;
  }

  mustCheckIfMessageDeleted(isPrivate: boolean): boolean {
    return false;
  }

  mustFetchContext(isPrivate): boolean {
    return false;
  }

  handlesPublish(): boolean {
    return false;
  }

  areAttachmentsAllowedWhenReplyingToPublicAsPrivate(): boolean {
    return true;
  }

  getSatisfactionSurveysExpirationHoursOptions(): number[] {
    return [0, 12, 23, 24, 36, 48, 60, 72, 84, 96, 240, 360];
  }

  getPrivateTaskTypes(): number[] {
    return [];
  }

  getMaxAllowedDaysToReplyToPrivateMsg(): number {
    return -1; // Only fb messenger has a limit for now
  }

  getTaskTypeString(taskType: number): string {
    return null;
  }

  taskTypeStringIsPrivate(taskTypeString: string): boolean {
    for (const type of this.getPrivateTaskTypes()) {
      if (this.getTaskTypeString(type) === taskTypeString) {
        return true;
      }
    }
    return false;
  }

  taskTypeIsPrivate(taskType: number): boolean {
    for (const type of this.getPrivateTaskTypes()) {
      if (type === taskType) {
        return true;
      }
    }
    return false;
  }

  getDefaultPrivateTaskType(): number {
    if (this.getPrivateTaskTypes().length > 0) {
      return this.getPrivateTaskTypes()[0];
    }
    return null;
  }

  /**
   * task.message.from.details.profile-id contains the channel username
   * ex: @toto for twitter
   * ex: facebook contains profil-id but it's not revelant, it means nothing
   */
  displayProfileId(): boolean {
    return false;
  }

  /**
   * For creation of scenario
   */
  isQuickReplyEnable(): number {
    return 1;
  }
}
